// src/ConsumerApp/api/checkout/checkout.hooks.js
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CheckoutService } from './checkout.service';

export const useProcessInstantCheckout = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload) => CheckoutService.processInstantCheckout(payload),
    onSuccess: (data, variables) => {
      const customerId = variables?.customer_id;
      // Invalidate bucket and order caches after checkout completion
      if (customerId) {
        queryClient.invalidateQueries({ queryKey: ['bucketSummary', customerId] });
        queryClient.invalidateQueries({ queryKey: ['bucketDetails', customerId] });
        queryClient.invalidateQueries({ queryKey: ['customerOrders', customerId] });
      }
    },
  });
};